<template>
  <div class="message">
    <div class="message-wrapper">
      <Avatar :name="name" :id="userId" class="message__avatar" />
      <div class="message__body">
        <div class="message__name" @click="$emit('replyTo', name)">
          {{ name }}
        </div>
        <div class="message__body">
          {{ body | stripMessage | badwords }}
        </div>
        <div class="message__timestamp">
          <timeago :auto-update="60" :datetime="createdAt"></timeago>
        </div>
      </div>
    </div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon class="message-actions">
          <v-icon size="18">$dots_vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="deleteMessage">
          <v-list-item-title>Delete message</v-list-item-title>
        </v-list-item>
        <v-list-item @click="deleteAllMessagesAndBlock">
          <v-list-item-title>Delete all messages from user</v-list-item-title>
        </v-list-item>
        <v-list-item @click="blockUser">
          <v-list-item-title class="red--text">Block user</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ChatMessage",
  props: {
    id: Number,
    chatId: Number,
    createdAt: String,
    userId: {
      type: Number,
      default() {
        return 0;
      },
    },
    name: {
      type: String,
      default: "Anonim",
    },
    body: String,
  },
  methods: {
    deleteMessage() {
      this.$api.Message.destroy(this.id);
    },
    blockUser() {
      if (confirm("Are you sure?")) {
        this.$api.Message.blockUser({ message_id: this.id });
      }
    },
    deleteAllMessagesAndBlock() {
      if (
        confirm("all messages from this user will be deleted. Are you sure?")
      ) {
        this.$api.Message.destroyAll({
          chat_id: this.chatId,
          user_id: this.userId,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.message {
  margin-bottom: 15px;
  position: relative;
}

.message-wrapper {
  display: flex;
}
.message__avatar {
  margin-right: 10px;
  min-width: 30px;
  width: 30px;
  height: 30px;
}

.message__name {
  font-size: 0.875em;
  font-weight: bold;
  cursor: pointer;
}

.message__body {
  font-size: 0.875em;
  white-space: pre-line;
  word-break: break-word;
}

.message__timestamp {
  font-size: 0.75em;
  color: rgb(155, 155, 155);
}

.message-actions {
  position: absolute;
  right: -15px;
  top: 0;
  display: none;
}
</style>
